<div class="sort-filter">
    <div class="sort-list">
        <div class="sort-select">
            <select class="custom-select"
                [(ngModel)]="pageSize"
                (ngModelChange)="pageSizeChange($event)">
                <option [ngValue]="20">Show 20</option>
                <option [ngValue]="50">Show 50</option>
                <option [ngValue]="100">Show 100</option>
            </select>
        </div>
        <span>{{ startRecordIndex }} – {{ endRecordIndex }} of {{ totalElements }}</span>
    </div>
    <div class="sort-pager">
        <button class="begin"
            (click)="begin()"
            [disabled]="pageNumber == 1"><i class="fas fa-step-backward"></i></button>
        <button class="prev"
            (click)="prev()"
            [disabled]="pageNumber == 1"><i class="fas fa-caret-left"></i></button>
        <span>Page</span>
        <input type="number"
            class="form-control"

            (input)="inputSubject.next($any($event.target).value)"
            (blur)="blurSubject.next($any($event.target).value)"
            [ngModel]="pageNumber">
        <span>of {{ totalPages }}</span>
        <button class="next"
            (click)="next()"
            [disabled]="pageNumber == totalPages"><i class="fas fa-caret-right"></i></button>
        <button class="end"
            (click)="end()"
            [disabled]="totalPages > 10"><i class="fas fa-step-forward"></i></button>
    </div>
    {{ temp }}
</div>
